<template lang="pug">
  section.section-color.section-param(id="specialists" class="pb-8 d-flex justify-center")
    v-container.container-team(fluid)
      v-card.title-style.margin-help(v-if="$vuetify.breakpoint.smAndDown")
        p.frontText Команда & специалисты
      v-card.title-style(v-else)
        p.frontText Команда & специалисты
        p.backText Команда & специалисты
      v-card.swiper-card.elevation-0(v-show="$vuetify.breakpoint.smAndDown")
        .swiper.swiper-pa-xs(ref='swiper')
          .swiper-wrapper
            v-card.swiper-slide.elevation-0(v-for="specialistTeam in specialistTeams" :key="specialistTeam.name" )
              swiperSpecialistTeamCard.mt-1(
                :team="specialistTeam",
                isSwiper
                @onBooking="$emit('onBooking', $event)"
                )
      v-card.groups-team.elevation-0(v-if="$vuetify.breakpoint.mdAndUp" )
        specialistTeamCard(
          v-for="(specialistTeam, i) in specialistTeams"
          :key="i"
          :team="specialistTeam"
          :num="i"
          @onBooking="$emit('onBooking', $event)"
          )
      v-card.bottom-card.elevation-0
        p.text Командная экспертиза: управление производством, банкинг, финтех, CRM/ERP, обучающие платформы, корпоративные порталы, учетные системы

</template>

<script>
import specialistTeamCard from './ui/SpecialistTeamCard'
import swiperSpecialistTeamCard from './ui/SwiperSpecialistTeamCard'
import Swiper, {EffectCoverflow, Navigation, Pagination} from "swiper"
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import "swiper/css/effect-coverflow"

export default {
  name: "SpecialistTeamSection",
  components: {
    specialistTeamCard,
    swiperSpecialistTeamCard
  },
  props: {
    specialistTeams: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      mySwiper: null,
    }
  },
  mounted() {
    this.mySwiper = new Swiper(this.$refs.swiper, {
      // configure Swiper to use modules
      modules: [EffectCoverflow, Navigation, Pagination],
      spaceBetween: -10,
      effect:'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',

      direction: 'horizontal',
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: false
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: true,
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })
  }
}
</script>

<style scoped lang="sass">
  @import "ui/scss/variables.scss"
  @import "ui/scss/colors.scss"

  @media(max-width: $smAndDown)
    .bottom-card
      margin-top: 0 !important
      color: $greyText

  @media (min-width: 1300px)
    .container-team
      background-image: url("~@/assets/RightUpGroup.png"), url("~@/assets/CenterGroup.png"), url("~@/assets/CenterGroup.png"), url("~@/assets/LeftDownGroup.png")
      background-size: auto auto
      justify-content: start

  @media (min-width: 1300px) and (max-width: 1700px)
    .groups-team
      margin-top: 80px!important

  @media (min-width: 1300px) and (max-width: 1400px)
    .container-team
      background-position: $marginImgRightUpGroup $marginImgRightUpGroupTop, 54% 31.8%, 46% 43.8%, $marginImgLeftDownGroup 71.5%

  @media (min-width: 1401px) and (max-width: 1500px)
    .container-team
      background-position: $marginImgRightUpGroup $marginImgRightUpGroupTop, 54% 32.2%, 45.8% 43.8%, $marginImgLeftDownGroup 71.5%

  @media (min-width: 1501px) and (max-width: 1600px)
    .container-team
      background-position: $marginImgRightUpGroup calc(5% + 106px), 53.8% 32.3%, 46% 43.8%, $marginImgLeftDownGroup 71.3%

  @media (min-width: 1601px) and (max-width: 1700px)
    .container-team
      background-position: $marginImgRightUpGroup calc(5% + 112px), 53.6% 32.4%, 46.3% 43.9%, $marginImgLeftDownGroup 71.3%

  @media (min-width: 1701px)
    .groups-team
      margin-top: 140px!important

  @media (min-width: 1701px) and (max-width: 1850px)
    .container-team
      background-position: $marginImgRightUpGroup 15%, calc(52.4% + 1vw) 33.5%, calc(45.4% + 1vw) 45.6%, $marginImgLeftDownGroup 72%

  @media (min-width: 1851px) and (max-width: 1900px)
    .container-team
      background-position: $marginImgRightUpGroup 15%, calc(52.3% + 1vw) 33.6%, calc(45.6% + 1vw) 45.9%, $marginImgLeftDownGroup 72%

  @media (min-width: 1901px) and (max-width: 1924px)
    .container-team
      background-position: $marginImgRightUpGroup 15.3%, calc(52.2% + 1vw) 33.7%, calc(45.7% + 1vw) 46%, $marginImgLeftDownGroup 72.3%

  @media (min-width: 1925px)  and (max-width: 1999px)
    .container-team
      background-position: calc($marginLeftContent + 1195px) 225px, calc($marginLeftContent + 732px) 483px, calc($marginLeftContent + 613px) 658px, $marginImgLeftDownGroup 1037px

  @media (min-width: 2000px)
    .container-team
      background-position: calc($marginLeftContent + 1195px) 227px, calc($marginLeftContent + 732px) 487px, calc($marginLeftContent + 613px) 665px, $marginImgLeftDownGroup 1043px

  @media(min-width: $xxl)
    .container-team
      background-position: 1417px 227px, 980px 486px, 860px 662px, 142px 1040px
      max-width: $maxWidthContainer
      margin: auto

  .swiper-card
    background-color: transparent
    height: 100%
    max-height: 570px
    min-width: $minWigthElement
    margin-left: $marginMax
    margin-right: $marginMax

  .swiper-visible
    display: none !important

  .swiper
    width: 100%
    height: 100%

  .swiper-pa-xs
    padding: 40px 0

  .swiper-slide
    max-width: 36%
    min-width: 300px
    height: auto
    padding: 0 15px
    opacity: 0.5
    min-height: 480px
    overflow: hidden
    position: relative
    counter-increment: slide
    background-color: transparent

  .slider-slide::after
    content: counter(slide)
    position: absolute
    top: 10px
    right: 20px
    color: $white
    font-style: italic
    font-size: 32px
    font-weight: bold

  .swiper-slide-active
    opacity: 1
    min-height: 480px
    min-width: 300px
    max-width: 36%

  .container-team
    background-color: $backgroundContainer
    min-width: $minWigthElement

  .groups-team
    background: transparent
    display: flex
    flex-wrap: wrap
    max-width: $maxWidthContent
    margin-left: $marginLeftContent
    margin-right: $marginRightContent
    margin-top: 6%
    border-radius: 20px

  .bottom-card
    margin-top: 40px
    margin-left: $marginMax
    margin-right: $marginRightContent
    display: flex
    max-width: 1380px
    background-color: $backgroundContainer
    .text
      font-family: GothamProClassic
      font-size: min(calc(14px + 0.6vw), 24px)
      line-height: 1.2

  .margin-help
    margin-bottom: 30px !important
    margin-top: 40px !important
</style>